import React from 'react'
import OrangeLink from './styled-components/OrangeLink'
import TermsOfServiceAndPrivacyPolicyContainer from './styled-components/TermsOfServiceAndPrivacyPolicyContainer'

export const TermsOfServiceAndPrivacyPolicy = () => {
  return (
    <TermsOfServiceAndPrivacyPolicyContainer>
      <OrangeLink href="https://www.anovaculinary.com/terms/">Terms of Service</OrangeLink>
      <OrangeLink href="https://www.anovaculinary.com/privacy/">&nbsp;&nbsp;&nbsp;Privacy Policy</OrangeLink>
    </TermsOfServiceAndPrivacyPolicyContainer>
  )
}

export const TermsOfServiceAndPrivacyPolicyFull = () => {
  return (
    <TermsOfServiceAndPrivacyPolicyContainer>
      By continuing, you are indicating that you accept our<br />
      <OrangeLink href="https://www.anovaculinary.com/terms/">Terms of Service&nbsp;</OrangeLink>and
      <OrangeLink href="https://www.anovaculinary.com/privacy/">&nbsp;Privacy Policy</OrangeLink>.
    </TermsOfServiceAndPrivacyPolicyContainer>
  )
}
